import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// 获取用户页面详情信息 http://wiki.xunlei.cn/pages/viewpage.action?pageId=132052625
export const xw_festival_homepage = createAsyncThunk(
  'live/activity/xw_festival_homepage',
  async (arg, store: any) => {
    const resp = await http.post('live/activity/xw_festival_homepage', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

interface recordItem {
  member?: {
    name?: string
    mid?: number
    avatar?: string
  }
  cardName?: string
  status?: number
  timeStr?: string // 0 为可赠送，1为已赠送
}
interface cardItem {
  id?: number
  img?: string
  name?: string
  num?: number
}
interface InitialStateType {
  friend_list?: recordItem[] // 雄王节好友列表
  my_send_list?: recordItem[] // 我赠送的好友列表
  my_receive_list?: recordItem[] // 我收到的好友列表
  card_list?: cardItem[] // 卡片数据列表
  is_first?: boolean // 是否是第一次
  remain_card_draw_times?: number // 可抽卡次数
  is_packed?: boolean // 是否集齐卡片
  daily_open_chest_num?: number // 开宝箱的人数
}

const initialState: InitialStateType = {}

export const XWFestivalSlice = createSlice({
  name: 'XWFestival',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(xw_festival_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default XWFestivalSlice.reducer
export const XWFestivalActions = XWFestivalSlice.actions
